"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHepatologyDiseases = createHepatologyDiseases;
const utils_1 = require("../../../events/utils");
const hepatologyDiseases_1 = require("../../../forms/ktx/transplantation-screening/medical-history/hepatologyDiseases");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    title: {
        id: "ktx.dashboard.hepatology_diseases",
        defaultMessage: "Hepatológiai betegségek"
    },
    cause: {
        id: "ktx.dashboard.hepatology_diseases.cause",
        defaultMessage: "Oka:"
    }
};
function createHepatologyDiseases(intl, { events }) {
    const { formatMessage, formatDate, formatMessageMap } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.medicalHistoryQueries.hepatologyDisease);
    const list = relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        items.push({
            type: "list-item",
            value: formatMessageMap(hepatologyDiseases_1.hepatologyTypeMessages, event.value.hepatologyType)
        });
        let cause = event.value.acuteLiverFailureCause;
        if (!cause) {
            cause = event.value.malignantDiseaseOfTheLiverCause;
        }
        if (!cause) {
            cause = event.value.metabolicLiverDiseaseCause;
        }
        if (!cause) {
            cause = event.value.vascularDiseasesOfTheLiverCause;
        }
        if (!cause) {
            cause = event.value.miscellaneousCause;
        }
        if (cause) {
            const allMessages = {
                ...hepatologyDiseases_1.acuteLiverFailureCauseMessages,
                ...hepatologyDiseases_1.malignantDiseaseOfTheLiverCauseMessages,
                ...hepatologyDiseases_1.metabolicLiverDiseaseCauseMessages,
                ...hepatologyDiseases_1.miscellaneousCauseMessages,
                ...hepatologyDiseases_1.vascularDiseasesOfTheLiverCauseMessages
            };
            items.push({
                type: "list-item",
                label: formatMessage(messages.cause),
                value: formatMessageMap(allMessages, cause)
            });
        }
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
    const content = (0, shared_1.createGroupContent)(list);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
